export default __webpack_public_path__ + "static/media/ic_edit.155d4ef1.svg";